import {
  InjectionToken,
  ModuleWithProviders,
  NgModule,
  inject,
  provideAppInitializer,
} from '@angular/core';
import { GainsightOptions } from '../models/gainsight.model';
import { GainsightService } from './services/gainsight';
import { GainsightPipe } from '../shared/custom-pipes/gainsight.pipe';

declare var aptrinsic: any;
export const OPTIONS = new InjectionToken<GainsightOptions>('OPTIONS');

// @dynamic
export function initialize(options: GainsightOptions) {
  const res = () => {
    const source = options.scriptSource
      ? options.scriptSource
      : 'https://web-sdk.aptrinsic.com/api/aptrinsic.js';
    const scriptName: any = 'aptrinsic';
    (window[scriptName] as any) =
      window[scriptName] ||
      ((...args: any[]) => {
        (window[scriptName]['q'] = window[scriptName]['q'] || []).push(...args);
      });
    window[scriptName]['p'] = options.tagKey;
    const newScript = document.createElement('script');
    ((newScript.async = !0), (newScript.src = source + '?a=' + options.tagKey));
    const scriptTags = document.getElementsByTagName('script')[0];
    if (scriptTags) {
      scriptTags?.parentNode?.insertBefore(newScript, scriptTags);
    } else {
      throw 'no scriptTag found';
    }
    if (options.config) {
      aptrinsic('identify', options.config.user, options.config.account);
    }
  };

  return res;
}

@NgModule({
  declarations: [GainsightPipe],
  imports: [],
  exports: [GainsightPipe],
  providers: [GainsightService],
})
export class GainsightModule {
  static forRoot(
    options: GainsightOptions,
  ): ModuleWithProviders<GainsightModule> {
    return {
      ngModule: GainsightModule,
      providers: [
        { provide: OPTIONS, useValue: options },
        provideAppInitializer(() => {
          const initializerFn = initialize(inject(OPTIONS));
          return initializerFn();
        }),
      ],
    };
  }
}
